module.exports = __webpack_public_path__ + "media/images/edit-pencil-0e53eae181e944f13002d9166b48b37a.svg";